import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainer from "components/Common/TableContainer";
import { useFormik } from "formik";
import * as Yup from "yup";

const departmentOptions = [
  { label: "QUALITY CONTROL", value: "QUALITY CONTROL" },
  { label: "CUTTING", value: "CUTTING" },
  { label: "Admin", value: "Admin" },
  { label: "STORE", value: "STORE" },
  { label: "IED", value: "IED" },
  { label: "PACKING", value: "PACKING" },
  { label: "PRODUCTION", value: "PRODUCTION" },
  { label: "QUALITY", value: "QUALITY" },
  { label: "ANCILLARY", value: "ANCILLARY" },
  { label: "EMBROIDERY", value: "EMBROIDERY" },
];

const categoryOptions = [
  { label: "Admin", value: "Admin" },
  { label: "Staff", value: "Staff" },
  { label: "Foreman", value: "Foreman" },
];

const AttendanceReportChecklist = () => {
  const formik = useFormik({
    initialValues: {
      category: "",
      department: "",
      fromDate: "",
      toDate: "",
    },
    validationSchema: Yup.object({
      fromDate: Yup.string().required("From Date is required"),
      toDate: Yup.string().required("To Date is required"),
    }),
    onSubmit: (values) => {
      console.log("Form Values:", values);
    },
  });

  const data = [
    { code: "0", name: "AES ADMIN", department: "Admin", present: "0.00", cl: "0.00", rl: "0.00", sl: "0.00", medl: "0.00", ml: "0.00", seml: "0.00", coff: "0.00", lop: "0.00", nfh: "2.00", weekoff: "0.00", total: "2.00", na: "42.00" },
    { code: "001", name: "ARUN", department: "QUALITY CONTROL", present: "0.00", cl: "0.00", rl: "0.00", sl: "0.00", medl: "0.00", ml: "0.00", seml: "0.00", coff: "0.00", lop: "0.00", nfh: "2.00", weekoff: "6.00", total: "8.00", na: "36.00" },
    { code: "002", name: "VIGNESH", department: "PRODUCTION", present: "1.00", cl: "0.00", rl: "0.00", sl: "0.00", medl: "0.00", ml: "0.00", seml: "0.00", coff: "0.00", lop: "0.00", nfh: "2.00", weekoff: "6.00", total: "9.00", na: "35.00" },
    { code: "003", name: "ULAGURAJ", department: "PACKING", present: "0.00", cl: "0.00", rl: "0.00", sl: "0.00", medl: "0.00", ml: "0.00", seml: "0.00", coff: "0.00", lop: "0.00", nfh: "2.00", weekoff: "6.00", total: "8.00", na: "36.00" },
    // Add more rows here based on your data source
  ];

  const columns = [
    { Header: "S No", Cell: ({ row }) => data.length - row.index, className: "serial-no text-center", },
    { Header: "EmpNo", accessor: "code" },
    { Header: "Emp Name", accessor: "name" },
    { Header: "Department Name", accessor: "department" },
    { Header: "Present", accessor: "present" },
    { Header: "CL", accessor: "cl" },
    { Header: "RL", accessor: "rl" },
    { Header: "SL", accessor: "sl" },
    { Header: "MedL", accessor: "medl" },
    { Header: "ML", accessor: "ml" },
    { Header: "SemL", accessor: "seml" },
    { Header: "COFF", accessor: "coff" },
    { Header: "LOP", accessor: "lop" },
    { Header: "NFH", accessor: "nfh" },
    { Header: "Weekoff", accessor: "weekoff" },
    { Header: "Total", accessor: "total" },
    { Header: "NA", accessor: "na" },
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Attendance" breadcrumbItem="Attendance Checklist" />

        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col md={6} lg={4}>
                  <Label>Category</Label>
                  <CustomSelect
                    name="category"
                    value={formik.values.category}
                    onChange={(val) => formik.setFieldValue("category", val)}
                    options={categoryOptions}
                    placeholder="--Select--"
                  />
                </Col>

                <Col md={6} lg={4}>
                  <Label>Department</Label>
                  <CustomSelect
                    name="department"
                    value={formik.values.department}
                    onChange={(val) => formik.setFieldValue("department", val)}
                    options={departmentOptions}
                    placeholder="--Select--"
                  />
                </Col>

                <Col md={6} lg={4}>
                  <Label>
                    From Date <span className="text-danger">*</span>
                  </Label>
                  <CustomDatePicker
                    name="fromDate"
                    value={formik.values.fromDate}
                    onChange={(val) => formik.setFieldValue("fromDate", val)}
                    onBlur={() => formik.setFieldTouched("fromDate", true)}
                  />
                  {formik.touched.fromDate && formik.errors.fromDate ? (
                    <div className="text-danger">{formik.errors.fromDate}</div>
                  ) : null}
                </Col>

                <Col md={6} lg={4}>
                  <Label>
                    To Date <span className="text-danger">*</span>
                  </Label>
                  <CustomDatePicker
                    name="toDate"
                    value={formik.values.toDate}
                    onChange={(val) => formik.setFieldValue("toDate", val)}
                    onBlur={() => formik.setFieldTouched("toDate", true)}
                  />
                  {formik.touched.toDate && formik.errors.toDate ? (
                    <div className="text-danger">{formik.errors.toDate}</div>
                  ) : null}
                </Col>

                <Col md={12} className="text-end">
                  <Button type="submit" className="btn button-search me-2 mt-2">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button type="button" className="btn button-print mt-2">
                    <i className="fas fa-print me-1" /> Print
                  </Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={data}
              isGlobalFilter={true}
              customPageSize={10}
              tableSorter={true}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default AttendanceReportChecklist;
